import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Reveal } from './Reveal';
const items = ['The 10 complete digital volumes (Elementary and Secondary)', 'Activities, projects and assessments by level', 'Artistic techniques with step-by-step explanation', 'Assessment and self-assessment rubrics', 'Portfolio templates and student work gallery'];
export function InstantAccessSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-291">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-292">
        <h2 className="mb-12 text-3xl font-black md:text-4xl" data-id="element-293">
          📲 What Do You Get Instantly?
        </h2>
        <div className="space-y-3 text-left" data-id="element-294">
          {items.map(item => <div key={item} className="flex items-center gap-4 rounded-2xl border border-brand-dark bg-brand-alt p-5 shadow-sm" data-id="element-295">
              <CheckCircle2Icon className="h-6 w-6 shrink-0 text-brand-red" aria-hidden="true" data-id="element-296" />
              <span className="font-semibold" data-id="element-297">{item}</span>
            </div>)}
        </div>
        <p className="mt-10 font-serif text-2xl font-bold italic text-brand-red" data-id="element-298">
          You cover a full year of material.
        </p>
      </Reveal>
    </section>;
}